import $ from "jquery";
import CONSTANT from "../../common/js/_constant";

const stickyBanner = {
    variables: {
        stickyBannerWrapper: ".sticky__banner--wrapper",
        stickyBannerClose: ".sticky__banner--close",
        body:"body",
        customSticky:".browse-article",
    },
    methods: {
        init: function () {
            const stickyBannerWrapper = $(stickyBanner.variables.stickyBannerWrapper);
            const stickyBannerClose = $(stickyBanner.variables.stickyBannerClose);
            const customSticky = $(stickyBanner.variables.customSticky);
            if(stickyBannerWrapper.length > 0  && $(window).width() < CONSTANT.breakpoints.md && customSticky.length > 0){
                $(customSticky.find('div')[0]).css({
                    "top":`124px`,
                })
            }
            stickyBannerClose.on("click", function () {
                stickyBannerWrapper.addClass("sticky__banner--hide");
                $(stickyBanner.variables.body).css({
                    "padding-top":`56px`,
                })
                $(customSticky.find('div')[0]).css({
                    "top":`56px`,
                })
                setTimeout(function () {
                    stickyBannerWrapper.remove();
                }, 1000);
            });
        },
    },
};

if ($(stickyBanner.variables.stickyBannerWrapper).length > 0) {
    stickyBanner.methods.init();
}
